import type { JSX } from "react";
import { PageSectionHeader } from "../../components/ui";
import { useBilling } from "./hooks/useBilling";
import { DailyTable } from "./billing/DailyTable";
import { EpisodesTable } from "./billing/EpisodesTable";
import { ErrorNotice } from "./billing/ErrorNotice";
import { LimitCard } from "./billing/LimitCard";

export function BillingPanel(): JSX.Element {
  const {
    daily,
    episodes,
    dailyLoading,
    episodesLoading,
    dailyError,
    episodesError,
    reloadDaily,
    reloadEpisodes,
  } = useBilling();
  const handleRetryDaily = (): void => {
    void reloadDaily();
  };
  const handleRetryEpisodes = (): void => {
    void reloadEpisodes();
  };

  return (
    <div className="px-6 py-5 space-y-2">
      <PageSectionHeader
        title="Billing"
        description="Per-day usage and recent agent episodes. All costs in USD."
      />

      <div className="h-3" />

      <span className="text-[11px] font-bold tracking-wider text-accent uppercase">Credit Limit</span>
      <div className="rounded-xl bg-surface-tertiary border border-edge overflow-hidden mt-2">
        <LimitCard />
      </div>

      <div className="h-3" />

      <span className="text-[11px] font-bold tracking-wider text-accent uppercase">Daily Usage</span>
      {dailyError && <ErrorNotice message={dailyError} onRetry={handleRetryDaily} />}
      <div className="rounded-xl bg-surface-tertiary border border-edge overflow-hidden mt-2">
        {dailyLoading ? (
          <div className="p-4 text-sm text-content-tertiary">Loading...</div>
        ) : (
          <DailyTable rows={daily} />
        )}
      </div>

      <div className="h-3" />

      <span className="text-[11px] font-bold tracking-wider text-accent uppercase">Recent Episodes</span>
      {episodesError && <ErrorNotice message={episodesError} onRetry={handleRetryEpisodes} />}
      <div className="rounded-xl bg-surface-tertiary border border-edge overflow-hidden mt-2">
        {episodesLoading ? (
          <div className="p-4 text-sm text-content-tertiary">Loading...</div>
        ) : (
          <EpisodesTable rows={episodes} />
        )}
      </div>
    </div>
  );
}
